import { Api } from "@api";
import { Draft } from "@api/drafts";
import { FilterType, Table } from "@components";
import { Cell, Row } from "@components/table/types";
import { Box } from "@material-ui/core";
import { format } from "date-fns";
import React, { useState } from "react";
import { TABLE_HEADERS } from "../constants";
import { useHistory } from "react-router-dom";
import DeleteIcon from "@material-ui/icons/Delete";
import { alertService } from "@services";
import { ConfirmationModal } from "../../request/steps/summary/views/summary/confirmation-modal";

const headers: Cell[] = [
  { data: TABLE_HEADERS.REF_NUMBER },
  { data: TABLE_HEADERS.DATE_ADDED },
  { data: TABLE_HEADERS.EFFECTIVE_DATE },
  { data: TABLE_HEADERS.REQUEST_TYPE },
  { data: "Remove" },
];

const formatDate = (date: string): string => {
  return date ? format(new Date(date), "yyyy-MM-dd") : "";
};

const getRequestType = (
  type: Draft["requestHeader"]["requestType"]
): string => {
  switch (type) {
    case 1:
      return "New Access";
    case 2:
      return "Modify Access";
    case 3:
      return "Revoke Access";
  }
};

export const Drafts: React.FC = () => {
  const history = useHistory();
  const [drafts, setDrafts] = useState<Draft[]>([]);
  const [isLoading, setIsloading] = useState<boolean>(true);
  const [isConfirming, setConfirmingState] = useState<boolean>(false);
  const [idToBeDeleted, setIdToBeDeleted] = useState<number|null>(null);
  const [modalMessage, setModalMessage] = useState<string>("");

  React.useEffect(() => {
    getDrafts();
  }, []);

  function getDrafts() {
    Api.drafts
      .getDrafts()
      .then((draftsResponse: Draft[]) => {
        setDrafts(draftsResponse);
        setIsloading(false);
      })
      .catch((err: any) => {
        console.error("there was an errror", err);
      });
  }

  const deleteIcon = (
    <span
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <DeleteIcon />
    </span>
  );
  
  // 12142020 change
  function handleConfirmationCancel() {
    closeConfirmationModal()
  }

  function handleConfirmationConfirm() {
    setConfirmingState(true);
    deleteMemberById(idToBeDeleted);
  }

  function openConfirmationModal(id: number)
  {
    setModalMessage("Are you sure do you want to remove this data?");
    setIdToBeDeleted(id);
    setConfirmingState(true);
  }

  function closeConfirmationModal()
  {
    setModalMessage("");
    setIdToBeDeleted(null);
    setConfirmingState(false);
  }

  const deleteMemberById = (id: number|null) => {
    if (id) {
      Api.drafts
        .delDraft(id)
        .then((response) => {
          if (response) {
            alertService.success({
              msg: "Draft item has been successfully removed.",
            });
            getDrafts();
          } else {
            alertService.danger({ msg: "Failed to delete." });
          }
          closeConfirmationModal()
        })
        .catch((error) => {
          console.log(error);
          closeConfirmationModal()
        });
    }
  };

  return (
    <Box mt={2}>
      <Table
        data={drafts.map((draft: any) => ({
          cells: [
            {
              data: draft.requestHeader.id.toString(),
              color: "blue",
              cursor: "pointer",
              onClick: () => {
                history.push(`/request?draft=${draft.id}`);
              },
            },
            { data: formatDate(draft.requestHeader.dateAdded) },
            {
              data: draft.requestHeader.effectiveDate
                ? formatDate(draft.requestHeader.effectiveDate)
                : "",
            },
            { data: getRequestType(draft.requestHeader.requestType) },
            {
              data: deleteIcon,
              color: "gray",
              cursor: "pointer",
              onClick: () => {
                openConfirmationModal(draft.id);
              },
            },
          ],
          data: draft,
        }))}
        tableName={"My Drafts"}
        headers={headers}
        filters={[FilterType.SORT, FilterType.PAGINATOR]}
        loading={isLoading}
      />
      <ConfirmationModal
        onCancel={handleConfirmationCancel}
        onConfirm={handleConfirmationConfirm}
        open={isConfirming}
        customMessage={modalMessage}
      />
    </Box>
  );
};
